import CPFValidator from './CPFValidator';
import EmailValidator from './EmailValidator';
import HourMinuteValidator from './HourMinuteValidator';

export {
  CPFValidator,
  EmailValidator,
  HourMinuteValidator,
}



// WEBPACK FOOTER //
// ./src/components/validators/index.js